import { call, takeLatest, select } from 'redux-saga/effects';
import { LINK_GUEST_USER } from 'redux/actions/actionTypes';
import { lifelineAPIs } from 'api';
import get from 'lodash/get';
import events from 'appAnalytics';

const getStateObj = ({ user, caseData }) => ({
  user,
  caseData,
});

function* linkGuestUser() {
  try {
    const { user = {}, caseData = {} } = yield select(getStateObj);
    const guestUserId = get(user, 'userId', '');
    const caseId = get(caseData, 'caseId', '');
    yield call(lifelineAPIs.linkGuestUser, {
      caseId,
      uId: guestUserId,
    });
  } catch (error) {
    const errObj = get(error, 'response.data', {});
    events.errorMsg.apiError({ apiName: 'linkGuestUser', errorResponse: { ...errObj } });
  }
}

export default function* userSagas() {
  yield takeLatest(LINK_GUEST_USER, linkGuestUser);
}
